<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>

          <!-- DOS FILAS INCICIALES -->
          <div class="row">
            <!-- Columnas para los campos, organizados en dos filas -->
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-12">
                  <label for="inputNombre" class="form-label" i18n>Nombre</label>
                  <input type="text" class="form-control" id="inputNombre" i18n-placeholder="@@nombrePlaceholder"
                    placeholder="Nombre" name="nombre" #nombre="ngModel" [(ngModel)]="plantilla.nombre" required
                    [ngClass]="{ 'is-invalid': (nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))}">
                  <div *ngIf="(nombre.invalid && f.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))">
                    <p class="validator-message" i18n>Campo obligatorio</p>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12 mb-3">
                </div>
              </div>
            </div>
          </div>


          <div class="text-md-end">
            <button type="submit" class="btn btn-primary waves-effect waves-light"><span i18n>Guardar</span></button>
          </div>

        </form>

      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->